/**
 * 表单校验
 *
 * @param formInstance 目标form表单实例
 * @return {Promise<boolean>}  true-校验通过、false-校验不通过
 */
export async function validateForm(formInstance) {
    if (!formInstance) {
        return false
    }

    try {
        await formInstance.validate()
        return true
    } catch {
        return false
    }
}
